import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ban",
  "use": "icon-ban-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-ban\"><title>Ban</title><circle fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"48\" cx=\"256\" cy=\"256\" r=\"200\" /><path stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"48\" d=\"M114.58 114.58l282.84 282.84\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol